module.exports = __webpack_public_path__ + "img/227.52e311aa.jpg";